import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from "@angular/router";
import { TranslatePipe } from '@ngx-translate/core';
import { AftersalesService } from '@services/aftersales.service';
import { AppModeEnum, AppState } from '@shared/app-state';
import { BreadcrumbService } from '@services/breadcrumb.service';
import { LoginService } from '@services/login.service';
import { BaseModal } from './base-modal';
// import { AftersalesService } from '@services/aftersales.service';

@Component({
    selector: 'abort-aftersales-modal',
    template: `
        <div class="modal-body">
        <button class="close" (click)="closeAndDestroy()">
            <i class="fa-light fa-xmark"></i>
        </button>
        <div class="log-out">
            <h3 class="text-center">{{ "HOMEFUNCTIONS.ABORTAFTERSALESHEADING" | translate }}</h3>
            <div class="form-group text-center">
                <button class="btn btn-secondary mr-3" (click)="closeAndDestroy()">{{ "COMMON.CANCEL" | translate }}</button>
                <button class="btn btn-primary" (click)="abort()">{{ "HOMEFUNCTIONS.ABORTAFTERSALES" | translate }}</button>
            </div>
        </div>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslatePipe]
})
export class AbortAftersalesComponent extends BaseModal {
	constructor(
		protected router: Router,
		protected loginService: LoginService,
		breadCrumbService: BreadcrumbService,
		protected aftersalesService: AftersalesService,
		public appState: AppState
	) {
		super(breadCrumbService);
	}

	async abort() {
		this.appState.appMode.next(AppModeEnum.default);
		this.loginService.Logout().then(() => {
			window.close();
			location.href = location.origin + "/login"; //Performing this redirect if window.close is unsuccessful
		})
	}
}
